import TextArea from "antd/es/input/TextArea"
import MyInput from "../../../components/ui/MyInput"
import { useEffect, useState } from "react"
const Facebook = ({ facebookFormData, data, setData, onSave }) => {
    const initialFacebookData = {
        app_id: "",
        client_token: "",
    }
    const [facebookData, setFacebookData] = useState(initialFacebookData)

    const updateFacebookDetails = (key, value) => {
        setFacebookData((state) => ({ ...state, [key]: value }))
    }

    useEffect(() => {

        const newFacebookData = { ...initialFacebookData }
        Object.keys(data).map(key => {
            if (key in initialFacebookData && data[key]) {
                newFacebookData[key] = data[key]
            }
        })

        setFacebookData(newFacebookData)
    }, [])

    return (
        <form className="flex flex-col gap-[20px] items-center p-[20px] "
            onSubmit={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setData(state => ({ ...state, ...facebookData }))
                onSave()
            }}
        >
            <div className="w-[1050px] flex flex-row justify-between">
                <div className="w-[500px]">
                    <MyInput value={facebookData.app_id} onChange={(e) => (updateFacebookDetails("app_id", e))} label={"Facebook App Id"} placeholder="Facebook app_id giriniz." />

                </div>
                <div className="w-[500px]">

                    <MyInput value={facebookData.client_token} onChange={(e) => (updateFacebookDetails("client_token", e))} label={"Facebook Client Token"} placeholder="Facebook client_token giriniz." />
                </div>

            </div>

            <button className="hidden" ref={facebookFormData} type="submit" ></button>
        </form>
    )
}

export default Facebook
